import { format, endOfWeek, startOfWeek } from "date-fns";
import { Fragment, useContext, useMemo, useState } from "react";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { Button } from "rizzui";
import cn from "../../../utils/classNames";
import CensusList from "./CensusList";
import { useNavigate } from "react-router-dom";
import { menuRoutes } from "../../../router/menu";

const CensusListWrapper = () => {
    
    // HOOKS
    const [isOpenImport, setIsOpenImport] = useState(false);

    const { userCan } = useContext(PrivilegeContext);
    const navigate = useNavigate();

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de censos' },
        { name: 'Censos', href: '/census' },
    ];

    const defaultFilters = useMemo(() => {
        const now = new Date();
        const weekStart = startOfWeek(now, { weekStartsOn: 1 });
        const weekEnd = endOfWeek(now, { weekStartsOn: 1 });
        return {
            status: null,
            between_dates: {
                startDate: format(weekStart, 'yyyy-MM-dd'),
                endDate: format(weekEnd, 'yyyy-MM-dd'),
                type: 'createdAt' as const,
            },
        };
    }, []);

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters}>
                <PageHeader title="Gestión de censos" breadcrumb={breadCrumb}>
                    {userCan('create', 'census') && (
                        <div className="flex flex-col md:flex-row gap-2">
                            {/*
                            <Button
                                color="primary"
                                onClick={() => { setIsOpenImport(true); }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Importar censos
                            </Button>
                            */}
                            <Button
                                color="primary"
                                onClick={() => {
                                    navigate(`${menuRoutes.census.path}/create`);
                                }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear Censo
                            </Button>
                        </div>
                    )}
                </PageHeader>
                <CensusList
                    isOpenImport={isOpenImport}
                    setIsOpenImport={setIsOpenImport}
                />
            </FiltersProvider>
        </Fragment>
    )

}

export default CensusListWrapper;
